import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import { nonames, state_array, nameRegExp } from "../../variables/Variables";

export default function LegalInformation({ state, onChange }) {
  function handleChange(event) {
    const { id, value } = event.target;
    const inputElement = document.getElementById(id);
    const errorElement = inputElement.nextSibling;
    if (id === "legalName") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Legal Name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Legal Name could contain only letters, numbers and & - symbols";
        errorElement.style.display = "block";
      } else if (!nameRegExp.test(value.trim()) || nonames.includes(value.trim().toLowerCase())) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML =
          "The Legal Name may not contain an ending such as 'LLC', 'LC', 'PLLC', 'PA', 'Corp', or 'Inc'.";
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }
    if (id === "dbaname") {
      if (value.trim().length !== 0) {
        if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "The Trade name/DBA could contain only letters, numbers and & - symbols";
          errorElement.style.display = "block";
        } else if (!nameRegExp.test(value.trim()) || nonames.includes(value.trim().toLowerCase())) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML =
            "The Trade name/DBA may not contain an ending such as 'LLC', 'LC', 'PLLC', 'PA', 'Corp', or 'Inc'.";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    onChange(event);
  }

  return (
    <>
      <h5>Legal information</h5>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Legal Name Of Church Controlled Organization</strong>
            <br />
            The only punctuation and special characters allowed are hyphen (-) and ampersand (&).
          </Tooltip>
        }
      >
        <Form.Group controlId="legalName">
          <Form.Label>Legal Name of the Church</Form.Label>
          <Form.Control
            required
            type="text"
            data-hj-allow
            placeholder="Name"
            pattern="(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
            maxLength="70"
            defaultValue={state.legalName}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid organization name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Trade Name / Doing Business As</strong>
            <br />A trade name or doing business as name is another name under which the business or individual
            operates. These names are identified by the terms &apos;trading as&apos; (TA), &apos;doing business as&apos; (DBA), or &apos;also
            known as&apos; (AKA). To file for a DBA, a separate filing with your state and county must be completed. We will
            send you instructions on how to complete this process.
          </Tooltip>
        }
      >
        <Form.Group controlId="dbaname">
          <Form.Label>Trade name or DBA of the Church</Form.Label>
          <Form.Control
            data-hj-allow
            type="text"
            placeholder="Optional"
            pattern="(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][pP][aA]$))(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
            maxLength="35"
            defaultValue={state.dbaname}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid Trade name or DBA</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <Form.Group controlId="organizedState">
        <Form.Label>State Organized</Form.Label>
        <Form.Control
          required
          as="select"
          className="form-control"
          name="organizedState"
          value={state.organizedState}
          onChange={onChange}
        >
          <option value="">Select a state</option>
          {Object.keys(state_array).map((prop, key) => (
            <option key={key} value={prop}>
              {state_array[prop]}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Please provide the state where the company was organized
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
